/**
 * Service Helper
 */

export const serviceHelper = {
  addressValidationURL: process.env.ADDRESS_VALIDATION_URL,
  addressValidationApiKey: process.env.ADDRESS_VALIDATION_API_KEY_PUBLIC,
  abandonCartSaveCustomer: process.env.ABANDON_CART_URL,
  abandonCartCheckedOut: process.env.ABANDON_CART_CHECKOUT_URL,
  orderServiceURL: process.env.ORDER_SERVICE_URL,
  bazaarvoiceJsURL: process.env.BAZAARVOICE_API_JS_URL,
  barcodeApiBaseUrl: process.env.BARCODE_API_BASE_URL,
  contactUsUrl: process.env.CONTACT_US_URL,
  customerLoginVerify: `${process.env.CUSTOMER_LOGIN_VERIFY_URL}`,
  customerEnableDigitalReceipt: `${process.env.CUSTOMER_ENABLE_DIGITAL_RECEIPT_URL}`,
  customerWishlistURL: process.env.CUSTOMER_WISHLIST_URL,
  customerAPIURL: process.env.CUSTOMER_API_URL,
  discoveryServiceUrl: process.env.RECEIPT_DISCOVERY_URL,
  serviceSuggestionsUrl: `${process.env.SERVICES_API_V2_URL}/services/suggestions`,
  fulfillmentBaseURL: process.env.FULFILLMENT_API_BASE_URL,
  fulfillmentApiKey: process.env.FULFILLMENT_API_KEY,
  jbCdnBaseUrl: 'https://jbhcdn.azureedge.net/public',
  marketingSource: process.env.EMAIL_MARKETING_SOURCE,
  marketingSubscribeURL: process.env.EMAIL_MARKETING_SUBSCRIBE_URL,
  phoneNumberCheckURL: process.env.PHONE_NUMBER_CHECK_URL,
  giftCardPDPBalanceCheckUrl: process.env.GIFTCARD_PDP_BALANCE_CHECK_URL,
  googleRecommendationEndpoint: process.env.GOOGLE_RECOMMENDATION_ENDPOINT,
  b2cBaseUrl: process.env.B2C_BASE_URL,
  b2cPathDetailsChange: process.env.B2C_PATH_DETAILS_CHANGE,
  b2cPathPasswordUpdate: process.env.B2C_PATH_PASSWORD_UPDATE,
  b2cPathSocialLink: process.env.B2C_PATH_SOCIAL_LINK,
  b2cPathSocialUnlink: process.env.B2C_PATH_SOCIAL_UNLINK,
  b2cPathLoginCreate: process.env.B2C_PATH_LOGIN_CREATE,
  b2cPathLogout: process.env.B2C_PATH_LOGOUT,
  customerAuthRefresh: process.env.CUSTOMER_AUTH_REFRESH,
  unifiedCustomerApi: process.env.UNIFIED_CUSTOMER_API,
  unifiedSubscriptionApi: process.env.UNIFIED_SUBSCRIPTION_API,
  preezieScriptUrl: process.env.PREEZIE_SCRIPT_URL,
  themeApisUrl: process.env.THEMEAPIS_URL,
  shopifyProductsGraphQlPath: process.env.SHOPIFY_PRODUCTS_GRAPHQL_PATH,
  shopifyProductsGraphQlToken: process.env.SHOPIFY_PRODUCTS_GRAPHQL_TOKEN,
  syndicatedContent: {
    syndigoId: process.env.SYNDICATED_CONTENT_SYNDIGO_ID,
  },
};
